<template>
  <div class="page-container mt-4">
    <section id="section__certificate">
      <StaticGuide>
        <template #logo><span></span></template>
        <template #contents>
          <v-row no-gutters class="py-8">
            <v-col cols="12">
              <p class="font--p-3 mt-10 mb-10">
                사장님 상점의 <br />
                소득 증명이 필요해요!
              </p>
              <p>
                아래 버튼을 누르시면 <br />
                카카오톡으로 인증이 진행됩니다.
              </p>
            </v-col>
          </v-row>
        </template>

        <template #activator>
          <v-row no-gutters>
            <v-col cols="12">
              <BasicButton @click="gotoKakao" :loading="nextLoading" :disabled="nextLoading">
                소득 증명 시작
              </BasicButton>
            </v-col>
          </v-row>
        </template>
      </StaticGuide>
    </section>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import StaticGuide from '@/components/common/guide/StaticGuide.vue'

export default {
  components: {
    StaticGuide,
  },
  data() {
    return {
      nextLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  created() {
    _meta({
      titles: ['소득금액증명원요청'],
    })
  },
  methods: {
    ...mapActions('document', ['easyLogin']),
    async gotoKakao() {
      this.nextLoading = true
      try {
        const data = await this.easyLogin()
        if (data.errorMessage !== '') {
          await this.$swal.basic.error({
            html: `카카오톡 인증에 오류가 발생하여 <br /> 고객센터로 문의해주세요`,
            icon: 'warning',
          })
        } else {
          this.$router.replace({
            name: 'signup/certification/confirm',
            query: { stepdata: data.stepData },
          })
        }
      } catch (e) {
        await this.$swal.basic.error({
          html: `카카오톡 인증에 오류가 발생하여 <br /> 고객센터로 문의해주세요`,
          icon: 'warning',
        })
      } finally {
        this.nextLoading = false
      }
    },
  },
}
</script>
